import { useMemo, useState } from 'react';
import ClassNames from '@streamloots/classnames';
import { PageFeedPermission } from '@streamloots/streamloots-types';
import { PageFeed } from 'model/indexTS';
import { TranslateInterface } from 'utils/translation';
import { FeedCommentsList } from '../feed-comments-list';
import { FeedHeader } from './FeedHeader';
import { FeedContent } from './FeedContent';
import { FeedFooter } from './FeedFooter';
import theme from './feed-list.scss';

const classNames = ClassNames(theme);

export interface FeedDetailProps extends TranslateInterface {
  lastVisitAt?: string;
  feed: PageFeed;
}

export const FeedDetail = ({ feed, lastVisitAt, t }: FeedDetailProps): JSX.Element => {
  const [showComments, setShowComments] = useState(false);

  const onlySubscribers = useMemo(() => feed.restrictedTo.includes(PageFeedPermission.ONLY_SUBSCRIBERS), [
    feed.restrictedTo,
  ]);

  const handleCommentClick = () => {
    setShowComments(!showComments);
  };

  return (
    <div className={classNames('feed-detail')}>
      <FeedHeader
        createdAt={feed.createdAt}
        t={t}
        onlySubscribers={onlySubscribers}
        feedId={feed._id}
        feedLikedCount={feed.summary.reactionCount}
        feedCommentCount={feed.summary.commentCount}
        lastVisitAt={lastVisitAt}
      />
      <FeedContent feed={feed} t={t} />
      <FeedFooter feed={feed} t={t} onCommentClick={handleCommentClick} showingComments={showComments} />
      {showComments && <FeedCommentsList feed={feed} />}
    </div>
  );
};
